export const LIST = 'list'
export const MAP = 'map'
